module.exports = {
      id: "speaker-usage",
      viewBox: "0 0 15 12",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#speaker",
      toString: function () {
        return this.url;
      }
    }